import { I18nShape } from '@tribeplatform/react-components/i18n'

import { BlockType, RegisteredBlock } from '../../types/index.js'
import { ToggleBlock as Component } from './Block.js'
import { ToggleProps } from './types.js'

export const RegisteredToggleBlock = (
  _intl: I18nShape,
): RegisteredBlock<ToggleProps> => ({
  recommendedName: 'Toggle',
  Component,
  config: {
    type: BlockType.BuildingBlock,
    defaultProps: {
      showChildrenOnEnabled: true,
    },
  },
})
